(() => {
  if (window.__kittelBannerTiltInit) return;
  window.__kittelBannerTiltInit = true;

  const selector = '[data-kittel-tilt]';
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  let active = null;
  let rafId = 0;
  let lastEvent = null;

  const supportsHover = () =>
    window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  const reset = (el) => {
    if (!el) return;
    el.style.removeProperty('--kittel-tilt-x');
    el.style.removeProperty('--kittel-tilt-y');
    el.style.removeProperty('--kittel-tilt-lift');
  };

  const update = () => {
    rafId = 0;
    if (!active || !lastEvent) return;
    const rect = active.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    const x = (lastEvent.clientX - rect.left) / rect.width - 0.5;
    const y = (lastEvent.clientY - rect.top) / rect.height - 0.5;

    const tiltX = clamp(-y * 6, -3, 3);
    const tiltY = clamp(x * 6, -3, 3);
    const lift = clamp(-y * 6, -4, 4);

    active.style.setProperty('--kittel-tilt-x', `${tiltX}deg`);
    active.style.setProperty('--kittel-tilt-y', `${tiltY}deg`);
    active.style.setProperty('--kittel-tilt-lift', `${lift}px`);
  };

  const onMove = (event) => {
    if (!active) return;
    lastEvent = event;
    if (!rafId) {
      rafId = window.requestAnimationFrame(update);
    }
  };

  const onEnter = (event) => {
    if (!supportsHover()) return;
    const target = event.target.closest(selector);
    if (!target) return;
    active = target;
    lastEvent = event;
    if (!rafId) {
      rafId = window.requestAnimationFrame(update);
    }
  };

  const onLeave = (event) => {
    const target = event.target.closest(selector);
    if (!target) return;
    if (active === target) {
      active = null;
      lastEvent = null;
    }
    reset(target);
  };

  document.addEventListener('pointerenter', onEnter, true);
  document.addEventListener('pointerleave', onLeave, true);
  document.addEventListener('pointermove', onMove, { passive: true });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden && active) {
      reset(active);
      active = null;
      lastEvent = null;
    }
  });
})();
